import React from "react";
import HomeScreen from "./HomeScreen";
import "./App.css";
function App() {
  return (
    <div className="app">
      <HomeScreen />
    </div>
  );
}

export default App;
